import baseColors from './base-colors.theme.js';
import { hexToRgb } from './helpers.js';

export interface Theme {
  [key: string]: string;
}

export const applyTheme = (theme: Theme): void => {
  const root = document.documentElement;
  for (const key of Object.keys(theme)) {
    root.style.setProperty(`--${key}`, theme[key] || baseColors[key]);
    root.style.setProperty(`--${key}-rgb`, hexToRgb(theme[key]) || baseColors[key]);
  }
};
